// reducers/hotel.reducer.js
const INITIAL_STATE = {
  hotelId: localStorage.getItem("hotelId"),
};

const hotelReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "SET_HOTEL_ID":
      return { ...state, hotelId: action.payload };

    case "CLEAR_HOTEL_ID":
      localStorage.removeItem("hotelId");
      return { ...state, hotelId: null };

    default:
      return state;
  }
};

export default hotelReducer;
